import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Button } from "reactstrap";
import { Helmet } from "react-helmet";
import Spinner from "../../Spinner/spinner";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { localeEs } from "../../locale/ag-grid-es";
import Breadcrumb from "../../breadCrum/breadCrum";
import withTokenCheck from "../../withTokenCheck";

const AppMovimientoCamas = ({ token }) => {
    const [infoMovimientoCamas, setInfoMovimientoCamas] = useState([]);
    const [loading, setLoading] = useState(true);
    const gridApi = useRef(null);
    const etiquetas = [
        "Inicio Lossman",
        "Reportes",
        "Reporte Movimiento De Camas",
    ];

    useEffect(() => {
        if (token) {
            axios
                .get("/movimientoestadia", {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((response) => {
                    setInfoMovimientoCamas(response.data);
                    setLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [token]);

    const defaultColDef = {
        sortable: true,
        resizable: true,
        filter: true,
        editable: true,
    };

    const columnDefs = [
        {
            field: "formulario.NumeroCaso",
            headerName: "Numero de Caso",
        },
        {
            field: "Persona",
            headerName: "Usuario",
        },
        {
            field: "TipoPersona",
            headerName: "Tipo de persona",
        },
        {
            field: "FechaInicial",
            headerName: "Fecha Inicial",
        },
        {
            field: "FechaFinal",
            headerName: "Fecha Final",
        },
        {
            field: "habitacion.NumeroHabitacion",
            headerName: "Numero de Cama",
        },
        {
            field: "evento.Nombre",
            headerName: "Evento",
        },
        {
            field: "created_at",
            headerName: "Fecha del evento",
        },
        {
            field: "created_by.name",
            headerName: "Usuario que modifico",
        },
    ];

    const handleExportCSV = () => {
        gridApi.current.exportDataAsCsv();
    };

    const onGridReady = (params) => {
        gridApi.current = params.api;
    };

    return (
        <>
            <Helmet>
                <title>Reporte Movimientos Cama</title>
            </Helmet>
            <div style={{ position: "relative" }}>
                {loading && <Spinner />}
                <div>
                    <Breadcrumb etiquetas={etiquetas} />
                </div>
                <div style={{ opacity: loading ? 0.5 : 1 }}>
                    <div className="container-fluid mt-5">
                        <Button color="success" onClick={handleExportCSV}>
                            Exportar CSV (Excel)
                        </Button>
                        <div
                            className="mt-3"
                            style={{ height: "500px", width: "100%" }}
                        >
                            <div
                                className="ag-theme-alpine"
                                style={{ height: "100%", width: "100%" }}
                            >
                                <AgGridReact
                                    rowData={infoMovimientoCamas}
                                    columnDefs={columnDefs}
                                    defaultColDef={defaultColDef}
                                    pagination={true}
                                    onGridReady={onGridReady}
                                    localeText={localeEs}
                                    paginationPageSize={20}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default withTokenCheck(AppMovimientoCamas);
